"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionType = void 0;
var PromotionType;
(function (PromotionType) {
    PromotionType["Dynamic"] = "dynamic";
    PromotionType["Static"] = "static";
    PromotionType["Trbo"] = "trbo";
})(PromotionType || (exports.PromotionType = PromotionType = {}));
//# sourceMappingURL=PromotionType.js.map